import React,{useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import '../assets/styles/pageloader.css';

export default function PageLoader(){
  const {pathname}=useLocation();
  const [visible,setVisible]=useState(true);
  useEffect(()=>{
    setVisible(true);
    const timer=window.setTimeout(()=>setVisible(false),pathname==='/'?650:380);
    return()=>window.clearTimeout(timer);
  },[pathname]);
  if(!visible)return null;
  return <div className="page-loader" role="status" aria-live="polite" aria-label="Loading page"><div className="loader-mark"><span className="loader-orbit" aria-hidden="true"/><img src="/logo.png" alt=""/><strong>technoration</strong><small>Smart Solutions, Endless Generations</small><span className="loader-progress" aria-hidden="true"/></div></div>;
}

